import {useContext, useEffect, useState} from 'react';
import {ServiceContext} from './Services';

const withInboxCount = (Component) => {
  return (props) => {
    const services = useContext(ServiceContext);
    const [count, setCount] = useState(0);

    useEffect(() => {
      return services.firebase.subscribeToInbox((unread) => setCount(unread));
    }, [services]);

    return <Component inboxCount={count} {...props}/>;
  }
};

export default withInboxCount;
